/* global Math */
import React, { Component } from "react";
//
import { ButtonControl } from "./Button";
import {
  getHumanDuration,
  getDurationHours,
  getDurationMinutes,
} from "../utils";

class DurationPicker extends Component {
  increment() {
    const { value, steps, onChange } = this.props;

    let idx = steps.indexOf(value);

    if (idx < steps.length - 1) {
      idx = idx + 1;
    }

    onChange(steps[idx]);
  }

  decrement() {
    const { value, steps, onChange } = this.props;

    let idx = steps.indexOf(value);

    if (idx > 0) {
      idx = idx - 1;
    }

    onChange(steps[idx]);
  }

  isMined() {
    const { value, steps } = this.props;
    const idx = steps.indexOf(value);

    return idx === 0;
  }

  isMaxed() {
    const { value, steps } = this.props;
    const idx = steps.indexOf(value);

    return idx === steps.length - 1;
  }

  getProgress() {
    const { value, steps } = this.props;
    const max = steps[steps.length - 1];

    return (value * 100) / max;
  }

  render() {
    const { value } = this.props;

    const progress = this.getProgress();
    const duration = getHumanDuration(value);
    const hh = getDurationHours(value);
    const mm = getDurationMinutes(value);

    const mined = this.isMined();
    const maxed = this.isMaxed();

    return (
      <div className="dpicker">
        <div className="progress">
          <div className="progress__bar" style={{ width: progress + "%" }}>
            <div className="progress__text">{duration}</div>
          </div>
        </div>

        <div className="screen__value">
          {hh > 0 && (
            <span>
              {hh}
              <small>h</small>
            </span>
          )}
          {mm > 0 && (
            <span>
              {mm}
              <small>min</small>
            </span>
          )}
        </div>

        <div>
          <ButtonControl
            icon="remove"
            disabled={mined}
            onClick={(ev) => this.decrement()}
          />
          <ButtonControl
            icon="add"
            disabled={maxed}
            onClick={(ev) => this.increment()}
          />
        </div>
      </div>
    );
  }
}

export default DurationPicker;
